var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"s-clickable-text",on:{"click":_vm.openGroup}},[_vm._v("&"+_vm._s(_vm.name))]),_c('span',[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }